import { useState, useEffect, useRef } from "react";

const LazyLoadImage = ({ src, alt, placeholder, className }) => {
  const [isVisible, setIsVisible] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once the image is loaded
        }
      },
      {
        threshold: 0.1, // Trigger when 10% of the image is visible
      }
    );

    const currentImageRef = imageRef.current;
    if (currentImageRef) {
      observer.observe(currentImageRef);
    }

    return () => {
      if (currentImageRef) {
        observer.unobserve(currentImageRef);
      }
    };
  }, []);

  return (
    <div ref={imageRef} className="relative">
      {isVisible ? (
        <img
          src={src}
          alt={alt}
          className={`transition-opacity duration-500 ease-in-out ${className}`}
        />
      ) : (
        <div
          className={`bg-gray-300 animate-pulse ${className}`}
          style={{
            backgroundImage: `url(${placeholder})`,
            backgroundSize: "cover",
          }}
        ></div>
      )}
    </div>
  );
};

export default LazyLoadImage;
